import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import { PAGE_THREATS } from '../../../config/pages';

const youtubeInit = () => {
    if (typeof window.YT === 'undefined') {
        const tag = document.createElement('script');
        tag.src = 'https://www.youtube.com/iframe_api';
        document.body.appendChild(tag);
    }
};

const Video = ({ playing, file }) => (
    <video
      src={ require(`../../../assets/video/${ file }`) }
      className={ cx('page-threats-video-overlay-item', { hide: playing }) }
      muted
      playsInline
      autoPlay
      loop
      width="100%"
    />
);

Video.propTypes = {
    playing: PropTypes.bool.isRequired,
    file: PropTypes.string.isRequired
};

class ThreatsVideo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            playing: false
        };

        this.playVideo = this.playVideo.bind(this);
        this.stopVideo = this.stopVideo.bind(this);
        this.videoPlaying = this.videoPlaying.bind(this);
        this.videoStopped = this.videoStopped.bind(this);

        this.player = null;
        window.onYouTubePlayerAPIReady = () => {
            this.player = new window.YT.Player('ytplayer', {
                videoId: this.props.videoId,
                playerVars: {
                    controls: 1,
                    disablekb: 1,
                    fs: 0,
                    modestbranding: 1,
                    playsinline: 1,
                    rel: 0,
                    showinfo: 0
                }
            });

            this.player.addEventListener('onStateChange', (e) => {
                if (e.data === 0 || e.data === 2) {
                    this.videoStopped();
                } else if ((e.data === 1 || e.data === 3) && this.props.page === PAGE_THREATS) {
                    this.videoPlaying();
                }
            });
        };
    }

    componentDidMount() {
        youtubeInit();

        if (typeof window.YT !== 'undefined') {
            window.onYouTubePlayerAPIReady();
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.page !== prevProps.page) {
            this.stopVideo();
            this.videoStopped();
        }
        if (this.props.videoId !== prevProps.videoId && this.player) {
            this.player.loadVideoById(this.props.videoId);
            this.player.mute();
            if (this.props.page !== PAGE_THREATS) {
                this.stopVideo();
            }
        }
    }

    playVideo() {
        if (this.player) {
            this.player.playVideo();
        }
    }

    stopVideo() {
        if (this.player) {
            this.player.stopVideo();
        }
    }

    videoPlaying() {
        this.setState({ playing: true });
    }

    videoStopped() {
        this.setState({ playing: false });
    }

    render() {
        const { playing } = this.state;
        const { t } = this.props;

        return (
            <div className="page-threats-video" id="page-threats-video">
                <div id="ytplayer" className="page-threats-video-yt"/>
                <div className={ cx('page-threats-video-overlay', { hide: playing }) }>
                    <Video playing={ playing } file={ t('threats.video.file') }/>
                    <div className="page-threats-video-overlay-cover"/>
                </div>
                <div className={ cx('page-threats-video-content', { hide: playing }) }>
                    <button className="page-threats-video-button" onClick={ this.playVideo }/>
                    <h3 className="page-threats-video-text">{ t('threats.video.text') }</h3>
                </div>
            </div>
        );
    }
}

ThreatsVideo.propTypes = {
    page: PropTypes.string.isRequired,
    t: PropTypes.func.isRequired,
    videoId: PropTypes.string.isRequired
};

export default ThreatsVideo;



// WEBPACK FOOTER //
// ./src/components/content/threats/ThreatsVideo.jsx